import { initializeClickableRowsContacts } from './functions';

if (document.querySelector(".reports")) {
    initializeClickableRowsContacts();
    window.downloadCurrentReport = function (format) {
        // If the report type is custom, check for the custom report ID
        const urlParams = new URLSearchParams(window.location.search);
        const currentPath = window.location.pathname;
        const baseRoute = currentPath.replace(/\/$/, ''); // Remove trailing slash if exists


        urlParams.set('download', 'true');
        urlParams.set('format', format);

        window.location.href = baseRoute + '/download?' + urlParams.toString();
    }
}
